import { PapiroConsole } from "src/utils/papiroConsole";

export default function articles(state = [], action) {
  switch (action.type) {
    case "ADD_CURRENT":
      return {
        ...state,
        article: action.article,
      };
    case "ADD_CURRENT_SEARCH":
      return {
        ...state,
        articlesearch: action.articlesearch,
        searchtype: action.searchtype
      };
    default:
      return state;
  }
}
